import {
  Avatar,
  ListItemAvatar,
  ListItemButton,
  ListItemText, Menu, MenuItem,
  Typography
} from '@mui/material'
import { blue } from '@mui/material/colors'
import React, { Fragment } from 'react'
import momentUtil from '../../util/momentUtil'
import notificationService from '../../services/notificationService'
import { Link } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import { UserAvatar } from './CustomAvatar'

const NotificationListItem = ({ notification, fetchNotifications, onDelete }) => {
  const { id, postId, title, body, createdDate, read } = notification
  const [contextMenu, setContextMenu] = React.useState(null)
  const { enqueueSnackbar } = useSnackbar()

  const notificationOnClickHandler = () => {
    const form = { read: true }
    form.read = true
    return notificationService.updateNotification(id, form)
      .then(res => {
        fetchNotifications()
      })
      .catch(err => enqueueSnackbar(err.response.data.message, { variant: 'error' }))
  }

  const notificationOnContextHandler = event => {
    event.preventDefault()
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6
          }
        : null
    )
  }

  const handleContextMenuCloseHandler = () => {
    setContextMenu(null)
  }

  const hideOnClickHandler = () => {
    setContextMenu(null)
    return notificationService.deleteNotification(id)
      .then(res => {
        onDelete()
      })
      .catch(err => enqueueSnackbar(err, { variant: 'error' }))
  }

  const renderContextMenu = (
    <Menu
      open={contextMenu !== null}
      onClose={handleContextMenuCloseHandler}
      anchorReference="anchorPosition"
      anchorPosition={
        contextMenu !== null
          ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
          : undefined
      }
    >
      <MenuItem onClick={hideOnClickHandler}>Hide</MenuItem>
    </Menu>
  )

  if (read) {
    return (
      <>
        <ListItemButton onClick={notificationOnClickHandler} onContextMenu={notificationOnContextHandler} component={Link} to={`/view-post/${postId}`}>
          <ListItemAvatar>
            <UserAvatar src={notification.avatarImageUrl}/>
          </ListItemAvatar>
          <ListItemText
            primaryTypographyProps={{ fontSize: '13px' }}
            primary={
              <>
                {title}
                <Typography sx={{ display: 'inline', fontSize: 13 }}
                            component="span"
                            variant="body2"
                            color="text.secondary">
                  {' - '}{momentUtil.createTimeDiffTag(createdDate)}
                </Typography>
              </>
            }
            secondaryTypographyProps={{ fontSize: '13px' }}
            secondary={body}
          />
        </ListItemButton>
        {renderContextMenu}
      </>
    )
  } else {
    return (
      <>
        <ListItemButton sx={{ bgcolor: '#263238' }} onClick={notificationOnClickHandler} onContextMenu={notificationOnContextHandler} component={Link} to={`/view-post/${postId}`}>
          <ListItemAvatar>
            <UserAvatar src={notification.avatarImageUrl} />
          </ListItemAvatar>
          <ListItemText
            primaryTypographyProps={{ fontSize: '13px' }}
            primary={
            <>
              {title}
              <Typography sx={{ display: 'inline', fontSize: 13 }}
                          component="span"
                          variant="body2"
                          color="text.secondary">
                {' - '}{momentUtil.createTimeDiffTag(createdDate)}
              </Typography>
            </>
          }
            secondaryTypographyProps={{ fontSize: '13px' }}
            secondary={body}
          />
        </ListItemButton>
        {renderContextMenu}
      </>
    )
  }
}

export default NotificationListItem
